(function () {
    'use strict';

    angular
        .module('franchiser.directives')
        .directive('unitBankingInfo', UnitBankingInfo)

    /** @ngInject */
    function UnitBankingInfo($q, $rootScope, HelperService, BankService, BankAccountService, BankAccountTypeService, PATHS_FRANCHISER) {
        function UnitBankingInfoController($scope) {
            const vm = this;

            vm.isCaixaBankSelected = () => vm.selectedBank && vm.selectedBank.Id == 9;

            vm.normalizeNumericField = (field, maxLength = null) => {
                if (!vm.unitBankAccount)
                    vm.unitBankAccount = {};

                if (vm.unitBankAccount[field] == null)
                    return;

                let value = onlyDigits(vm.unitBankAccount[field]);

                if (maxLength)
                    value = value.slice(0, maxLength);

                vm.unitBankAccount[field] = value;
            }

            vm.validateAccount = () => {
                if (!vm.isCaixaBankSelected()) return true;
                if (!vm.selectedBankAccountType || !vm.selectedBankAccountType.Id) return true;

                const account = onlyDigits(vm.unitBankAccount.Account);

                // A instrucao exibida na tela manda digitar a OPERACAO com 3 digitos (003 corrente,
                // 022 poupanca) e as contas gravadas usam a forma curta (3..., 2...). As duas valem:
                // aceitar so uma delas reprova justamente quem seguiu o texto da propria tela.
                if (vm.selectedBankAccountType.Id == 1)
                    return account && (account.startsWith('3') || account.startsWith('003'));
                else if (vm.selectedBankAccountType.Id == 2)
                    return account && (account.startsWith('2') || account.startsWith('022'));

                return false;
            }

            vm.saveUnitBanking = () => {
                if (!vm.unitBankAccount)
                    vm.unitBankAccount = {};

                if (!vm.selectedBank) {
                    HelperService.setErrorMessageForm('.bank');
                    return;
                }

                if (!vm.selectedBankAccountType) {
                    HelperService.setErrorMessageForm('.bankAccountType');
                    return;
                }

                HelperService.startLoading('.unitBankingForm');

                vm.unitBankAccount.UnitId = vm.unitData.Id;
                vm.unitBankAccount.BankId = vm.selectedBank.Id;
                vm.unitBankAccount.BankAccountTypeId = vm.selectedBankAccountType.Id;

                if (!vm.unitBankAccount.Id) {
                    BankAccountService
                        .postBankAccount(prepareBankAccountPayload(vm.unitBankAccount))
                        .then(success => {
                            vm.unitBankAccount = normalizeBankAccount(success);
                            vm.isAccountImport = false;

                            if (vm.isFranchisee) {
                                vm.canUserEdit = $rootScope.canUserEdit && (!vm.unitBankAccount || !vm.unitBankAccount.Id);
                            }

                            HelperService.successCallback();
                            HelperService.stopLoading('.unitBankingForm');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.unitBankingForm');
                        })
                } else {
                    BankAccountService
                        .putBankAccount(prepareBankAccountPayload(vm.unitBankAccount), vm.isAccountImport)
                        .then(success => {
                            vm.unitBankAccount = normalizeBankAccount(success);
                            vm.isAccountImport = false;

                            HelperService.successCallback('update');
                            HelperService.stopLoading('.unitBankingForm');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.unitBankingForm');
                        })
                }
            }

            vm.importBankAccountInfo = () => {
                vm.unitBankAccount = normalizeBankAccount(vm.selectedUnitAccountImport);
                vm.selectedBank = vm.banks.find(bank => (bank.Id == vm.unitBankAccount.BankId));
                vm.selectedBankAccountType = vm.bankAccountTypes.find(bankAccType => (bankAccType.Id == vm.unitBankAccount.BankAccountTypeId));

                vm.unitBankAccount.Bank = null;
                vm.unitBankAccount.BankAccountType = null;
                vm.selectedUnitAccountImport = null;
                vm.isAccountImport = true;
            }

            vm.cancelBankAccountImport = () => {
                vm.selectedUnitAccountImport = null;
                vm.isAccountImport = false;
            }

            let removeWatchShow = $scope.$watch('vm.show', (newValue, oldValue) => {
                if (newValue)
                    init();
            })

            $scope.$on('$destroy', () => {
                removeWatchShow();
            })

            function init() {
                vm.canUserCreate = $rootScope.canUserCreate;
                vm.removeMessage = $rootScope.removeMessage;
                vm.isAccountImport = false;

                getUnitBankAccount();
            }

            function getBanks() {
                return BankService.getAll()
            }

            function getBankAccountTypes() {
                return BankAccountTypeService.getAll()
            }

            function getUnitEconomicGroupAccounts() {
                return BankAccountService.getByUnitEconomicGroup(vm.unitData.EconomicGroupId);
            }

            // Agency/Account e os digitos viajam como TEXTO desde o alinhamento de schema de
            // 17/06/2026 (BankAccount.Account int -> varchar). Os inputs eram type="number", e o
            // AngularJS NAO renderiza model string nesse tipo: a conta voltava vazia ao abrir a aba
            // e, depois de salvar, a conta e os dois digitos tambem. O dado no banco sempre esteve
            // correto - o que sumia era a exibicao.
            function normalizeBankAccount(bankAccount) {
                if (!bankAccount)
                    return bankAccount;

                let normalized = angular.copy(bankAccount);

                normalized.Agency = onlyDigits(normalized.Agency);
                normalized.AgencyDigit = onlyDigits(normalized.AgencyDigit);
                normalized.Account = onlyDigits(normalized.Account);
                normalized.AccountDigit = onlyDigits(normalized.AccountDigit);

                return normalized;
            }

            function prepareBankAccountPayload(bankAccount) {
                let normalized = normalizeBankAccount(bankAccount);

                // Agency continua int no DTO da API; os demais campos sao string.
                if (normalized.Agency)
                    normalized.Agency = parseInt(normalized.Agency, 10);

                if (!normalized.AgencyDigit)
                    normalized.AgencyDigit = null;

                if (!normalized.AccountDigit)
                    normalized.AccountDigit = null;

                return normalized;
            }

            function onlyDigits(value) {
                if (value == null)
                    return '';

                return value.toString().replace(/\D/g, '');
            }

            function getUnitBankAccount() {
                HelperService.startLoading('.unitBankingForm');

                $q.all([getBanks(), getBankAccountTypes(), getUnitEconomicGroupAccounts()])
                    .then(success => {
                        vm.banks = success[0];
                        vm.bankAccountTypes = success[1];
                        vm.unitGroupBankAccounts = success[2];

                        BankAccountService
                            .getByUnitId(vm.unitData.Id)
                            .then(success => {
                                if (success) {
                                    success = normalizeBankAccount(success);

                                    vm.selectedBank = vm.banks.find(bank => (bank.Id == success.BankId));
                                    vm.selectedBankAccountType = vm.bankAccountTypes.find(bankAccType => (bankAccType.Id == success.BankAccountTypeId));
                                    vm.unitBankAccount = success;

                                    if (success.Id)
                                        vm.unitGroupBankAccounts = vm.unitGroupBankAccounts.filter(bankAccount => (bankAccount.Id != vm.unitBankAccount.Id));
                                }

                                if (vm.isFranchisee) {
                                    vm.canUserEdit = $rootScope.canUserEdit && (!vm.unitBankAccount || !vm.unitBankAccount.Id);
                                } else {
                                    vm.canUserEdit = $rootScope.canUserEdit;
                                }

                                HelperService.stopLoading('.unitBankingForm');
                            }, error => {
                                HelperService.errorCallback(error);
                            })
                    })
            }
        }

        return {
            bindToController: true,
            controller: UnitBankingInfoController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/unit-banking-info/unit-banking-info.html`,
            scope: {
                unitData: '=',
                show: '=',
                isFranchisee: '='
            }
        }
    }
}());